var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLookingGlassIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h24v24H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,6c3.4,0,6.4,1.7,8.2,4.4c0.4,0.7,0.4,1.5,0,2.2C18.4,15.3,15.4,17,12,17s-6.4-1.7-8.2-4.4c-0.4-0.7-0.4-1.5,0-2.2 C5.6,7.7,8.6,6,12,6 M12,4C7.3,4,3.3,6.7,1.4,10.7c-0.2,0.5-0.2,1.1,0,1.6c1.9,4,6,6.7,10.6,6.7s8.7-2.7,10.6-6.7 c0.2-0.5,0.2-1.1,0-1.6C20.7,6.7,16.7,4,12,4z M12,9c1.6,0,2.8,1.5,2.4,3.2c-0.2,0.8-0.9,1.5-1.7,1.7c-1.7,0.4-3.2-0.8-3.2-2.4 C9.5,10.1,10.6,9,12,9 M13.2,7.2c-3.4-0.9-6.5,2.1-5.6,5.6c0.4,1.5,1.6,2.7,3.1,3.1c3.4,0.9,6.5-2.1,5.6-5.6 C15.9,8.8,14.7,7.6,13.2,7.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookingGlassIcon);
export default __webpack_public_path__ + "static/media/LookingGlassIcon.23bb702eb9df245fcf882e858ecc2c87.svg";
export { ForwardRef as ReactComponent };